import styled from '@emotion/styled';
import moment from 'moment';
import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {mixinFlexboxRow} from 'webapp-lib/styling';

import {TimeEntryResponse} from '@lexian/api/timetracker-api';

function formatDuration(totalSeconds: number) {
  // Format manually instead of via moment.utc(...).format('HH:mm:ss'),
  // which wraps around at 24 hours.
  const clampedSeconds = Math.max(totalSeconds, 0);
  const hours = Math.floor(clampedSeconds / 3600);
  const minutes = Math.floor((clampedSeconds - hours * 3600) / 60);
  const seconds = clampedSeconds - hours * 3600 - minutes * 60;

  return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
}

export function ElapsedTime({
  ongoingEntry,
}: {
  ongoingEntry: TimeEntryResponse;
}): React.ReactElement {
  const {t} = useTranslation('timetracker');

  const [elapsedSeconds, setElapsedSeconds] = useState(0);
  const {startTime} = ongoingEntry;

  useEffect(() => {
    const updateElapsedTime = () => {
      setElapsedSeconds(moment().diff(moment(startTime), 'seconds'));
    };

    updateElapsedTime();
    const interval = setInterval(updateElapsedTime, 1_000);

    return () => clearInterval(interval);
  }, [startTime]);

  return (
    <StyledElapsedTime>
      <div>
        {t('components.timer.startTime', {
          time: moment(ongoingEntry.startTime).format('HH:mm'),
        })}
      </div>
      <div>{formatDuration(elapsedSeconds)}</div>
    </StyledElapsedTime>
  );
}

const StyledElapsedTime = styled.div`
  ${mixinFlexboxRow};
  align-items: center;
  gap: var(--gutter-large);
`;
